module.exports = __webpack_public_path__ + "static/oklahoma-city-f7e3e06fcff5c44fe7a8bbd8be18e75c.png";